import Snap from 'imports-loader?wrapper=window&additionalCode=module.exports=0;!snapsvg/dist/snap.svg.js';

$(document).ready(function () {
    function getPathCenterPercentage(pathElement, svgElement) {
        const pathRect = pathElement.getBoundingClientRect();
        const svgRect = svgElement.getBoundingClientRect();
    
        const pathCenterX = pathRect.left + pathRect.width / 2;
        const pathCenterY = pathRect.top + pathRect.height / 2;
    
        const relativeX = pathCenterX - svgRect.left;
        const relativeY = pathCenterY - svgRect.top;
    
        const percentX = (relativeX / svgRect.width) * 100;
        const percentY = (relativeY / svgRect.height) * 100;
    
        return {
            percentX: percentX.toFixed(2),
            percentY: percentY.toFixed(2),
            absoluteX: relativeX,
            svgWidth: svgRect.width
        };
    }

    $( ".interactive-map-block" ).each(function() {
        var block = $(this);
        var map = $(this).find(".interactiveMap");
        var svg = map[0];
        var s = Snap(svg);

        // Text
        var selectedText = $('.interactive-map-selected');
        var hoverText = $('.interactive-map-hover');

        // Regions
        var anglesey = s.select('.anglesey');
        var angleseyIsland1 = s.select('.anglesey-island-1');
        var angleseyIsland2 = s.select('.anglesey-island-2');
        var blaenauGwent = s.select('.blaenau-gwent');
        var bridgend = s.select('.bridgend');
        var caerphilly = s.select('.caerphilly');
        var cardiff = s.select('.cardiff');
        var carmarthenshire = s.select('.carmarthenshire');
        var ceredigion = s.select('.ceredigion');
        var chester = s.select('.chester');
        var conwy = s.select('.conwy');
        var denbighshire = s.select('.denbighshire');
        var flintshire = s.select('.flintshire');
        var forestOfDean = s.select('.forest-of-dean');
        var gwynedd = s.select('.gwynedd');
        var herefordshire = s.select('.herefordshire');
        var merthyrTydfil = s.select('.merthyr-tydfil');
        var monmouthshire = s.select('.monmouthshire');
        var neathPortTalbot = s.select('.neath-port-talbot');
        var neston = s.select('.neston');
        var newport1 = s.select('.newport-1');
        var newport2 = s.select('.newport-2');
        var northShropshire = s.select('.north-shropshire');
        var pembrokeshire = s.select('.pembrokeshire');
        var powys = s.select('.powys');
        var rhonddaCynonTaff = s.select('.rhondda-cynon-taff');
        var swansea = s.select('.swansea');
        var torfaen = s.select('.torfaen');
        var valeOfGlamorgan = s.select('.vale-of-glamorgan');
        var wirral = s.select('.wirral');
        var wrexham = s.select('.wrexham');

        // Interactions
        function updateInfowrapHeight(label) {
            const $infowrap = $('.interactive-map-infowrap');
            let $activeInfo = null;
        
            block.find('.interactive-map-info').each(function () {
                const $info = $(this);
                const isMatch = $info.data("label") === label;
        
                if (isMatch) {
                    $activeInfo = $info;
                    $info.show().stop(true, true).animate({ opacity: "1" }, 300);
                    $info.attr('aria-hidden', 'false');
                } else {
                    $info.stop(true, true).animate({ opacity: "0" }, 300, function () {
                        $info.css('display', 'none');
                    });
                    $info.attr('aria-hidden', 'true');
                }
            });
        
            if (label == 0 || !$activeInfo) {
                $infowrap.css('height', '0px');
            } else {
                $infowrap.css('height', $activeInfo.height());
            }
        }
        
        // Change event
        block.find('.interactive-map-select').on('change', function () {
            const label = $(this).val();
            const $targetPath = map.find(`path[data-label="${label}"]`);
        
            $targetPath.first().trigger("click");
            $targetPath.addClass("__selected");
        
            updateInfowrapHeight(label);
        });

        $(window).on('resize', function () {
            const label = block.find('.interactive-map-select').val();
            updateInfowrapHeight(label);
        });

        map.find('path').click(function () {
            map.find('path').removeClass('__selected');

            selectedText.css({
                'display': 'none',
                'top': 'auto',
                'left': 'auto',
                'right': 'auto',
            });

            var label = $(this).data("label");
            var coords = getPathCenterPercentage(this, s.node);

            selectedText.text(label);

            selectedText.css({
                'display': 'block',
                'top': coords.percentY + '%',
                'left': '',
                'right': ''
            });

            const labelWidth = selectedText.outerWidth();

            if (coords.absoluteX + labelWidth > coords.svgWidth) {
                // Overflowing, align from right instead
                const rightPercent = 100 - coords.percentX;
                selectedText.css('right', rightPercent + '%');
            } else {
                selectedText.css('left', coords.percentX + '%');
            }
            if(block.find('.interactive-map-select').val() != label){
                block.find('.interactive-map-select').val(label).change();
            }
        });

        map.find('path').mouseover(function () {

            hoverText.css({
                'display': 'none',
                'top': 'auto',
                'left': 'auto',
                'right': 'auto',
            });

            var label = $(this).data("label");
            var coords = getPathCenterPercentage(this, s.node);

            hoverText.text(label);

            hoverText.css({
                'display': 'block',
                'top': coords.percentY + '%',
                'left': '',
                'right': ''
            });

            const labelWidth = hoverText.outerWidth();

            if (coords.absoluteX + labelWidth > coords.svgWidth) {
                // Overflowing, align from right instead
                const rightPercent = 100 - coords.percentX;
                hoverText.css('right', rightPercent + '%');
            } else {
                hoverText.css('left', coords.percentX + '%');
            }
        }).mouseout(function () {
            hoverText.text("");
            hoverText.css({
                'display': 'none',
                'top': 'auto',
                'left': 'auto',
                'right': 'auto',
            });
        });

        function bindRegionEvents(elements, options = {}) {
            const {
                highlightColor = '#59B2E4',
                defaultColor = '#B5DBF2',
                highlightOpacity = null,
                defaultOpacity = null
            } = options;
        
            elements.forEach(el => {
                el.mouseover(() => {
                    elements.forEach(e =>
                        e.attr({
                            fill: highlightColor,
                            ...(highlightOpacity !== null && { 'fill-opacity': highlightOpacity })
                        })
                    );
                });
        
                el.mouseout(() => {
                    elements.forEach(e =>
                        e.attr({
                            fill: defaultColor,
                            ...(defaultOpacity !== null && { 'fill-opacity': defaultOpacity })
                        })
                    );
                });
        
                el.click(() => {
                    elements.forEach(e => e.addClass('__selected'));
                });
            });
        }
        
        // Bind events alphabetically by region
        
        bindRegionEvents([anglesey, angleseyIsland1, angleseyIsland2]);
        
        bindRegionEvents([blaenauGwent]);
        bindRegionEvents([bridgend]);
        bindRegionEvents([caerphilly]);
        bindRegionEvents([cardiff]);
        bindRegionEvents([carmarthenshire]);
        bindRegionEvents([ceredigion]);
        
        bindRegionEvents([chester], {
            highlightColor: '#59B2E4',
            defaultColor: '#8BC4EA',
            highlightOpacity: 1,
            defaultOpacity: 0.7
        });
        
        bindRegionEvents([conwy]);
        bindRegionEvents([denbighshire]);
        bindRegionEvents([flintshire]);
        
        bindRegionEvents([forestOfDean], {
            highlightColor: '#59B2E4',
            defaultColor: '#8BC4EA',
            highlightOpacity: 1,
            defaultOpacity: 0.7
        });
        
        bindRegionEvents([gwynedd]);
        
        bindRegionEvents([herefordshire], {
            highlightColor: '#59B2E4',
            defaultColor: '#8BC4EA',
            highlightOpacity: 1,
            defaultOpacity: 0.7
        });
        
        bindRegionEvents([merthyrTydfil]);
        bindRegionEvents([monmouthshire]);
        bindRegionEvents([neathPortTalbot]);
        
        bindRegionEvents([neston], {
            highlightColor: '#59B2E4',
            defaultColor: '#8BC4EA',
            highlightOpacity: 1,
            defaultOpacity: 0.7
        });
        
        bindRegionEvents([newport1, newport2]);
        
        bindRegionEvents([northShropshire], {
            highlightColor: '#59B2E4',
            defaultColor: '#8BC4EA',
            highlightOpacity: 1,
            defaultOpacity: 0.7
        });
        
        bindRegionEvents([pembrokeshire]);
        bindRegionEvents([powys]);
        bindRegionEvents([rhonddaCynonTaff]);
        bindRegionEvents([swansea]);
        bindRegionEvents([torfaen]);
        bindRegionEvents([valeOfGlamorgan]);
        
        bindRegionEvents([wirral], {
            highlightColor: '#59B2E4',
            defaultColor: '#8BC4EA',
            highlightOpacity: 1,
            defaultOpacity: 0.7
        });
        
        bindRegionEvents([wrexham]);
        
    });
});